import React from 'react';
import PropTypes from 'prop-types';
import Simplified from './views/Simplified';
import MoreLike from './views/MoreLike';

const MORE_LIKE_POSTER = 'moreLike';
const SIMPLIFIED_POSTER = 'simplified';

const PosterV2 = ({ type, ...rest }) => {
  const components = {
    // latestEpisode: LatestEpisode,
    // poster: Poster,
    [SIMPLIFIED_POSTER]: Simplified,
    [MORE_LIKE_POSTER]: MoreLike,
  };
  if (!type) return null;
  const Component = components[type];
  if (!Component) return null;
  return <Component {...rest} />;
};

PosterV2.propTypes = { type: PropTypes.string.isRequired };

export { PosterV2, MORE_LIKE_POSTER, SIMPLIFIED_POSTER };
